import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { BillingStatusRequest } from '../../requests/orchestrator-billing-by-health-unit/billing-status.request';
import { MonthlyProgrammedBillingResponse } from '../../responses/orchestrator-billing-by-health-unit/monthly-programmed-billing.response';
import { PostExcelReportResponse } from '../../responses/orchestrator-billing-by-health-unit/post-excel-report.response';

@Injectable({
  providedIn: 'root'
})
export class MonthlyProgrammedBillingService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  listBillingPlan(date: Date, idHealthUnit?: number, idPlan?: number): Observable<MonthlyProgrammedBillingResponse> {
    let uri = `MonthlyProgrammedBilling?`;

    if(idHealthUnit)
      uri += `idHealthUnit=${idHealthUnit}&`;

    if(idPlan)
      uri += `idPlan=${idPlan}&`;

    return this.httpClient.post<MonthlyProgrammedBillingResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiOrchestratorBillingByHealthUnit) + uri, date, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  postMonthlyBillingExcel(date: Date): Observable<PostExcelReportResponse> {
    let uri = `MonthlyProgrammedBilling/excel`

    return this.httpClient.post<PostExcelReportResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiOrchestratorBillingByHealthUnit) + uri, date, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  putMonthlyBillingStatus(idMonthlyProgrammedBilling: number, body: BillingStatusRequest): Observable<ReturnStruct> {
    let uri = `MonthlyProgrammedBilling/idMonthlyProgrammedBilling/${idMonthlyProgrammedBilling}`;

    return this.httpClient.put<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiOrchestratorBillingByHealthUnit) + uri, body, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}